import React from "react";
import { motion } from "framer-motion";
import { GAMES } from "../data/games";
import { PlayFdjButton } from "./FdjAffiliate";
import { Calendar, TrendingUp, CalendarClock } from "lucide-react";

export const GameHero = ({ game, drawCount, affiliateUrl, jackpot, nextDraw }) => {
  const cfg = GAMES[game];
  return (
    <motion.div
      key={game}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`relative overflow-hidden rounded-3xl p-6 sm:p-10 mb-8 text-white shadow-xl bg-gradient-to-br ${cfg.gradient}`}
    >
      <div className="absolute inset-0 opacity-15"
        style={{ backgroundImage: "url(https://images.unsplash.com/photo-1757689216934-8c7907b44a28?crop=entropy&cs=srgb&fm=jpg&q=60&w=1200)", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="relative">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-4">
          <Calendar className="w-3.5 h-3.5" /> {cfg.badge}
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">{cfg.name}</h1>
        <div className="mt-3 flex flex-wrap items-end gap-x-8 gap-y-2">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-white/70">Jackpot</div>
            <div className="text-2xl sm:text-3xl font-black" style={{ color: "#FFE27A" }}>{jackpot || cfg.jackpot}</div>
          </div>
          {nextDraw && (
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-white/70">Prochain tirage</div>
              <div className="text-base sm:text-lg font-extrabold flex items-center gap-1.5">
                <CalendarClock className="w-4 h-4" /> {nextDraw}
              </div>
            </div>
          )}
          <div className="flex items-center gap-1.5 text-white/90 font-bold">
            <TrendingUp className="w-4 h-4" /> {Number(drawCount || 0).toLocaleString("fr-FR")} tirages analysés
          </div>
        </div>
        <div className="mt-5">
          <PlayFdjButton url={affiliateUrl} game={game} gameColor="#D4001A" testId={`hero-play-fdj-${game}`} />
        </div>
      </div>
    </motion.div>
  );
};
